import { motion, useReducedMotion } from "framer-motion";
import { SPRING } from "../lib/motion";

/**
 * A one-shot entrance as an element scrolls into view.
 *
 * Used sparingly — section headings and stat tiles. Revealing every element on
 * a page turns a nice touch into a page that will not sit still.
 *
 * Reduced motion keeps the fade and drops the travel: the cue survives, the
 * vestibular trigger does not.
 */
export default function Reveal({
  as = "div",
  delay = 0,
  className = "",
  children,
  ...rest
}) {
  const reduce = useReducedMotion();
  const Component = motion[as] || motion.div;

  return (
    <Component
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y: 16 }}
      whileInView={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -10% 0px" }}
      transition={
        reduce
          ? { duration: 0.2, ease: "easeOut", delay }
          : { ...SPRING.ui, delay }
      }
      {...rest}
    >
      {children}
    </Component>
  );
}
